import * as React from "react";
import { LazyImage } from "@grandvisionhq/common";
const FooterPaymentOptions = ({ items }) => {
  if (!items.length) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: "footer__payment" }, /* @__PURE__ */ React.createElement("ul", { className: "footer__payment-items" }, items.map((item, index) => /* @__PURE__ */ React.createElement("li", { key: `payment-item-${index}`, className: "footer__payment-item" }, /* @__PURE__ */ React.createElement(LazyImage, { src: item.url, alt: item.description ?? "", width: 48, height: 30 })))));
};
export {
  FooterPaymentOptions
};
//# sourceMappingURL=FooterPaymentOptions.js.map
